import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { BillingRatesComponent } from './billing-rates/billing-rates.component';

const routes: Routes = [
  { path: '', component: BillingRatesComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdvancedBillingRoutingModule { }
